









































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import GroupTagVirtualList from '@/components/Group/GroupTagVirtualList.vue'

type SelectEntry = {
  id: string | number
  choose: boolean
  _displayName: string
  _searchText: string
  _sourceItem: any
  [key: string]: unknown
}

@Component({
  components: {
    GroupTagVirtualList
  }
})
export default class ModalGroupTagSelect extends Vue {
  @Prop({ default: 'modal-group-tag-select' }) private id!: string
  @Prop({ default: '' }) private title!: string
  @Prop({ default: () => [] }) private listItem!: any[]
  @Prop({ default: () => [] }) private listSelected!: any[]
  @Prop({ default: 'name' }) private displayNameKey!: string
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: false }) revertUnsubmittedSelection!: boolean

  private listSearch: SelectEntry[] = []
  private listChoose: SelectEntry[] = []
  private searchKeyword = ''
  private submitted = false
  private initialSnapshot: { id: string | number; inChoose: boolean }[] = []
  private sourceItemById = new Map<string | number, any>()

  get filteredListSearch(): SelectEntry[] {
    const keyword = this.searchKeyword.trim().toLowerCase()
    if (!keyword) return this.listSearch
    return this.listSearch.filter(item => item._searchText.includes(keyword))
  }

  @Watch('listItem')
  @Watch('listSelected')
  @Watch('displayNameKey')
  onListChange() {
    this.buildLists()
  }

  @Watch('loading')
  onLoadingChange(isLoading: boolean) {
    if (!isLoading) {
      this.buildLists()
    }
  }

  mounted() {
    this.buildLists()
  }

  handleShow() {
    this.searchKeyword = ''
    this.submitted = false
    this.buildLists()
    if (this.revertUnsubmittedSelection) {
      this.saveSnapshot()
    }
  }

  handleHidden() {
    if (this.revertUnsubmittedSelection && !this.submitted) {
      this.restoreSnapshot()
    }
    this.submitted = false
  }

  buildLists() {
    const selectedIds = new Set(this.listSelected.map(i => i.id))
    const chooseIds = new Set<string | number>()
    const searchCandidates: SelectEntry[] = []
    const nextListChoose: SelectEntry[] = []
    const nextSourceItemById = new Map<string | number, any>()

    this.listItem.forEach(item => {
      if (item.id == null) return
      if (!nextSourceItemById.has(item.id)) {
        nextSourceItemById.set(item.id, item)
      }

      const entry = this.createEntry(item)
      if (selectedIds.has(item.id) || item.selected) {
        if (chooseIds.has(item.id)) return
        chooseIds.add(item.id)
        nextListChoose.push(entry)
      } else {
        searchCandidates.push(entry)
      }
    })

    this.sourceItemById = nextSourceItemById
    this.listSearch = searchCandidates.filter(item => !chooseIds.has(item.id))
    this.listChoose = nextListChoose
  }

  saveSnapshot() {
    const chooseIds = new Set(this.listChoose.map(i => i.id))
    this.initialSnapshot = [
      ...this.listSearch.map(i => ({ id: i.id, inChoose: false })),
      ...this.listChoose.map(i => ({ id: i.id, inChoose: true }))
    ]
    void chooseIds
  }

  restoreSnapshot() {
    const chooseIds = new Set(
      this.initialSnapshot.filter(s => s.inChoose).map(s => s.id)
    )
    const allItems = [...this.listSearch, ...this.listChoose]
    this.listSearch = allItems
      .filter(i => !chooseIds.has(i.id))
      .map(i => ({ ...i, choose: false }))
    this.listChoose = allItems
      .filter(i => chooseIds.has(i.id))
      .map(i => ({ ...i, choose: false }))
  }

  handleChooseSource(item: SelectEntry) {
    item.choose = !item.choose
  }

  handleChooseDestination(item: SelectEntry) {
    item.choose = !item.choose
  }

  addToListChoose() {
    const toMove = this.listSearch.filter(item => item.choose)
    if (!toMove.length) return
    this.listChoose = [
      ...this.listChoose,
      ...toMove.map(i => ({ ...i, choose: false }))
    ]
    this.listSearch = this.listSearch.filter(item => !item.choose)
  }

  removeFromListChoose() {
    const toRemove = this.listChoose.filter(item => item.choose)
    if (!toRemove.length) return
    this.listSearch = [
      ...this.listSearch,
      ...toRemove.map(i => ({ ...i, choose: false }))
    ]
    this.listChoose = this.listChoose.filter(item => !item.choose)
  }

  selectAll() {
    this.listChoose = [
      ...this.listChoose,
      ...this.listSearch.map(i => ({ ...i, choose: false }))
    ]
    this.listSearch = []
  }

  unselectAll() {
    this.listSearch = [
      ...this.listSearch,
      ...this.listChoose.map(i => ({ ...i, choose: false }))
    ]
    this.listChoose = []
  }

  handleCancel() {
    if (this.revertUnsubmittedSelection && !this.submitted) {
      this.restoreSnapshot()
    }
    this.$bvModal.hide(this.id)
  }

  onSubmit() {
    const selected = this.listChoose.map(
      item => this.sourceItemById.get(item.id) ?? item._sourceItem
    )
    this.submitted = true
    this.$emit('submit', selected)
    this.$bvModal.hide(this.id)
  }

  createEntry(item: any): SelectEntry {
    const displayName = this.getDisplayNameFromSource(item)
    return {
      ...item,
      choose: false,
      _displayName: displayName,
      _searchText: displayName.toLowerCase(),
      _sourceItem: item
    }
  }

  getDisplayNameFromSource(item: Record<string, unknown>): string {
    const val = item[this.displayNameKey] ?? item.name
    return String(val ?? '')
  }
}
